import { render, staticRenderFns } from "./folderLocationPickerDialog.vue?vue&type=template&id=b357a888&scoped=true&lang=pug"
import script from "./folderLocationPickerDialog.vue?vue&type=script&lang=js"
export * from "./folderLocationPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./folderLocationPickerDialog.vue?vue&type=style&index=0&id=b357a888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b357a888",
  null
  
)

export default component.exports